import { useCallback, useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Modal from "./components/Modal";
import AppContext from "./Context/AppContext";
import BookAppointmentPage from "./pages/BookAppointmentPage"; // ADDED [06/07/2026]
import ContactPage from "./pages/ContactPage";
import DevelopersLeadPage from "./pages/DevelopersLeadPage";
import NotFoundPage from "./pages/NotFoundPage";

import "./App.css";

function App() {
  let location = useLocation();
  const { pathname } = location;

  const [formData, setFormData] = useState({});
  const [referral, setReferral] = useState(null);
  const [trackingCode, setTrackingCode] = useState("");
  const [modal, setModal] = useState({ modalOpen: false, modalContent: null });
  const [isNewBuild, setIsNewBuild] = useState(true);
  // ADDED [09/07/2026]: appointmentType drives the Hero2 strapline content on
  // /book-appointment routes. Determined by pathname, same pattern as referral etc.
  const [appointmentType, setAppointmentType] = useState(null);

  useEffect(() => {
    const root = document.getElementById("root");
    root.classList.add("flex", "flex-col", "min-h-screen");

    const main = document.getElementsByTagName("main")[0];
    main.classList.add("flex-1");
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    // ADDED [06/07/2026]: /book-appointment falls through to referral: null already -
    // no change needed here, since it has no referral partner and the final ternary
    // branch already resolves to null for any unmatched pathname.
    setReferral(
      params.get("ref")
        ? params.get("ref")
        : pathname === "/taylor-wimpey" || pathname === "/taylor-wimpey/"
        ? "t"
        : pathname === "/persimmon" || pathname === "/persimmon/"
        ? "p"
        : pathname === "/alan-hawkins" || pathname === "/alan-hawkins/"
        ? "ah"
        : null,
    );

    // AMENDED [09/07/2026]: Added /book-appointment/protection-review tracking
    // code branch (CABAPRJY26), checked before the generic /book-appointment
    // branch since it's a more specific path.
    // Previously:
    // setTrackingCode(
    //   pathname === "/taylor-wimpey" ||
    //     pathname === "/taylor-wimpey/" ||
    //     params.get("ref") === "t"
    //     ? "CABATJU24"
    //     : pathname === "/persimmon" ||
    //       pathname === "/persimmon/" ||
    //       params.get("ref") === "p"
    //     ? "CABAPJU24"
    //     : pathname === "/enquiries" || pathname === "/enquiries/"
    //     ? "CADLJU24"
    //     : pathname === "/alan-hawkins" ||
    //       pathname === "/alan-hawkins/" ||
    //       params.get("ref") === "ah"
    //     ? "CABAAHJU26"
    //     : pathname === "/book-appointment" || pathname === "/book-appointment/"
    //     ? "CABAJY26"
    //     : "CABAGJU24",
    // );
    // AMENDED [13/07/2026]: Removed the "/book-appointment" branch (CABAJY26) -
    // this pathname is dead code now that the generic /book-appointment route
    // was removed from Routes [09/07/2026]; it can never be hit and always
    // fell through to the NotFoundPage catch-all instead.
    // Previously:
    // setTrackingCode(
    //   pathname === "/taylor-wimpey" ||
    //     pathname === "/taylor-wimpey/" ||
    //     params.get("ref") === "t"
    //     ? "CABATJU24"
    //     : pathname === "/persimmon" ||
    //       pathname === "/persimmon/" ||
    //       params.get("ref") === "p"
    //     ? "CABAPJU24"
    //     : pathname === "/enquiries" || pathname === "/enquiries/"
    //     ? "CADLJU24"
    //     : pathname === "/alan-hawkins" ||
    //       pathname === "/alan-hawkins/" ||
    //       params.get("ref") === "ah"
    //     ? "CABAAHJU26"
    //     : pathname === "/book-appointment/protection-review" ||
    //       pathname === "/book-appointment/protection-review/"
    //     ? "CABAPRJY26"
    //     : pathname === "/book-appointment" || pathname === "/book-appointment/"
    //     ? "CABAJY26"
    //     : "CABAGJU24",
    // );
    setTrackingCode(
      pathname === "/taylor-wimpey" ||
        pathname === "/taylor-wimpey/" ||
        params.get("ref") === "t"
        ? "CABATJU24"
        : pathname === "/persimmon" ||
          pathname === "/persimmon/" ||
          params.get("ref") === "p"
        ? "CABAPJU24"
        : pathname === "/enquiries" || pathname === "/enquiries/"
        ? "CADLJU24"
        : pathname === "/alan-hawkins" ||
          pathname === "/alan-hawkins/" ||
          params.get("ref") === "ah"
        ? "CABAAHJU26"
        : pathname === "/book-appointment/protection-review" ||
          pathname === "/book-appointment/protection-review/"
        ? "CABAPRJY26"
        : "CABAGJU24",
    );

    // AMENDED [06/07/2026]: Added /book-appointment to the isNewBuild: false branch
    // (confirmed not a new-build page).
    // Previously:
    // setIsNewBuild(
    //   pathname === "/alan-hawkins" || pathname === "/alan-hawkins/"
    //     ? false
    //     : true,
    // );
    // AMENDED [09/07/2026]: Added /book-appointment/protection-review to the
    // isNewBuild: false branch too - client confirmed the book-appointment form
    // stays isNewBuild: false regardless of appointment type.
    // Previously:
    // setIsNewBuild(
    //   pathname === "/alan-hawkins" ||
    //     pathname === "/alan-hawkins/" ||
    //     pathname === "/book-appointment" ||
    //     pathname === "/book-appointment/"
    //     ? false
    //     : true,
    // );
    setIsNewBuild(
      pathname === "/alan-hawkins" ||
        pathname === "/alan-hawkins/" ||
        pathname === "/book-appointment" ||
        pathname === "/book-appointment/" ||
        pathname === "/book-appointment/protection-review" ||
        pathname === "/book-appointment/protection-review/"
        ? false
        : true,
    );

    // ADDED [09/07/2026]: appointmentType is determined by pathname, same
    // hardcoded-string pattern as referral/trackingCode/isNewBuild above.
    // "general" covers /book-appointment on its own (no specific type yet);
    // add further branches here as new appointment types are introduced.
    setAppointmentType(
      pathname === "/book-appointment/protection-review" ||
        pathname === "/book-appointment/protection-review/"
        ? "protection-review"
        : pathname === "/book-appointment" || pathname === "/book-appointment/"
        ? "general"
        : null,
    );
  }, [pathname]);

  // FIX: useCallback ensures stable references are passed via context,
  // preventing useEffect loops in consumers that include these in their dep arrays.
  const handleFormData = useCallback((updatedData) => {
    setFormData((prev) => ({ ...prev, ...updatedData }));
  }, []);

  const handleSetModal = useCallback((object) => {
    setModal(object);
  }, []);

  return (
    <AppContext.Provider
      value={{
        formData: formData,
        setFormData: handleFormData,
        referral: referral,
        modal: modal,
        trackingCode: trackingCode,
        setModal: handleSetModal,
        isNewBuild: isNewBuild,
        appointmentType: appointmentType, // ADDED [09/07/2026]
      }}
    >
      <>
        <Header />
        <main>
          <div className="mt-16">
            <Routes>
              <Route path="/" element={<ContactPage />} />
              <Route path="/persimmon" element={<ContactPage />} />
              <Route path="/taylor-wimpey" element={<ContactPage />} />
              <Route path="/alan-hawkins" element={<ContactPage />} />
              {/* REMOVED [09/07/2026]: Generic /book-appointment route removed - an
                  appointment type is now required in the path. Falls through to
                  the catch-all NotFoundPage route below instead.
                  Previously:
                  <Route
                    path="/book-appointment"
                    element={<BookAppointmentPage />}
                  />
              */}
              {/* ADDED [09/07/2026]: Protection review appointment type, nested under
                  /book-appointment. Reuses BookAppointmentPage - the form stays the
                  same across appointment types, only the Hero2 content changes
                  based on appointmentType from context. */}
              <Route
                path="/book-appointment/protection-review"
                element={<BookAppointmentPage />}
              />
              <Route path="/enquiries" element={<DevelopersLeadPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </div>
        </main>
        <Footer />
        <Modal modal={modal} />
      </>
    </AppContext.Provider>
  );
}

export default App;
